import * as React from 'react'
import { t } from 'i18next'
import { mkWidget, Widget } from 'widgets-for-react'
import { oldSites } from '../../../../../public_site.main.mod';
var recruitmentProcessJson = require('../../../../../../wwwroot/recruitmentProcess.json');

export const recruitmentProcessBlock = (job: string, language: string) => (index: number): Widget<any> =>
  mkWidget({
    run: (_) => {
      let recruitmentProcess = getRecruitmentProcess(job)

      let corporateSite = oldSites.getIn(['global']).replace('/en/', '')
      let isCorporateSite =
        window.location.origin?.startsWith(corporateSite)
        || window.location.origin?.startsWith("http://localhost:5000/en") // testing locally
        || window.location.origin?.startsWith("https://refresco-refresco.acceptatie.viddadigital.com") //  acceptance

      let lng = isCorporateSite ? 'en' : language
      return (
        <>
          {recruitmentProcess != undefined && (
            <section className="block block--recruit">
              <div className="block__inner container container--m grid--gutter">
                <h2 className="block__title title--s">
                  {t(`RecruitmentProcess:title`)}
                </h2>
                <ul className="block__list">
                  {recruitmentProcess.steps.map((steps, i) => (
                    <li className="block__item item" key={`classforRecruitmentProcess-selector-${i + 1}`}>
                      <div className="item__inner">
                        <div className="item__number">
                          <svg className="item__icon" width="60" height="56" viewBox="0 0 60 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M39.3295 4.11478C28.9574 -0.26157 17.0341 2.61327 9.94932 11.1462C3.11201 19.4229 2.14659 31.1969 7.40068 40.4806C12.6529 49.746 23.7808 55.4957 34.6819 53.6829C47.0378 51.6321 55.5396 40.3158 55.6699 28.5052C55.5396 18.0312 49.3238 8.34465 39.3295 4.11478ZM40.2737 54.0857C28.8625 58.1874 15.4297 55.6787 7.17164 46.7429C-1.12042 37.7522 -2.33145 24.3118 4.111 14.021C10.4212 3.91327 23.0624 -1.32371 35.0026 0.287666C48.9814 2.19202 59.5633 13.8745 59.7333 27.5346V27.5529C59.5822 39.4917 51.8154 49.9291 40.2737 54.0857Z" fill="#FBD5A0" />
                          </svg>
                          <span className="item__label">{i + 1}</span>
                        </div>
                        <p className="item__text">
                          {i + 1 === 1
                            ? t(`RecruitmentProcess:stepOne`)
                            : i + 1 === 2
                            ? t(`RecruitmentProcess:stepTwo`)
                            : t(`RecruitmentProcess:stepThree`)}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
                <p className="block__disclaimer">
                  {t(`RecruitmentProcess:disclaimerText`)}
                </p>
              </div>
            </section>
          )}
        </>
      )
    }
  })

export type RecruitmentSteps<T extends string> = { [p in T]: string }

export type RecruitmentProcess = {
  job: string
  steps?: RecruitmentSteps<"en" | "uk" | "nl" | "fr" | "pl" | "de" | "es" | "fi" | "it">[]
}

export const getRecruitmentProcessData = (): RecruitmentProcess[] => recruitmentProcessJson

export const getRecruitmentProcess = (job: string): RecruitmentProcess => {
  let recruitmentProcess = getRecruitmentProcessData()
  let selectedRecruitmentProcess = recruitmentProcess.find((f) => f.job == job)
  if (selectedRecruitmentProcess == undefined) {
    selectedRecruitmentProcess = recruitmentProcess.find((f) => f.job == "Default")
  }
  return selectedRecruitmentProcess
}
